module.exports = __webpack_public_path__ + "img/nav-persona.86604647.svg";